import { api } from "#lib/http-client"

class ContactService {
  async basicArtistApplication(data: { email: string; socialMediaOrWebsite: string }): Promise<any> {
    return this.sendContactForm({ email: data.email, artist: true, additionalInfo: data.socialMediaOrWebsite })
  }

  async sendContactForm(data: { email: string; artist: boolean; additionalInfo?: string }): Promise<any> {
    return api().post("/newsletter-mail-adresses", data)
  }
}

export const contactService = new ContactService()
